export const HOME = "/";
export const SIGNUP = "/signup";
export const LOGIN = "/login";
export const PROFILE = "/profile";

export const START = "/start";
export const END = "/end-day/:dayId";
export const ADD_TASK = "/add-task";
export const MARK_COMPLETE = "/mark-complete";
export const VIEW_DAY = "/viewday/:dayId";
export const USERS = "/users";
export const UNKNOWN_ROUTE = "*"

export const UNAUTHORIZED_ROUTES_MAPPING = {
    ADMIN: [],
    EMPLOYEE: [USERS]
}
